module.exports = {
    RECEIVE_COUNTRY: 'RECEIVE_COUNTRY',
    RECEIVE_COUNTRIES: 'RECEIVE_COUNTRIES',
}
